import { api } from '../api';
import { saveJsonAsFile } from '../helpers/utilityFunctions/utilityFunctions';

export const activeTestService = {
  GetPatientTests,
  GetPatientTestDetail,
  GetPatientTestTableDataByCategory,
  GetPatientTestTableDataByCategories,
  GetActiveTestOverview,
  GetActiveTestDatesByRange,
  GetActiveTestDataByDate,
  DownloadActiveTestDataFile,
};

function GetPatientTests(patientId: string, type: string) {
  return api.get(`/activetest/tests?patientId=${patientId}&activeType=${type}`);
}

function GetPatientTestDetail(testGuid: string, type: string) {
  return api.get(
    `/activetest/tests/data?testGuid=${testGuid}&activeType=${type}&responseType=detail`
  );
}

function GetPatientTestTableDataByCategory(
  testGuid: string,
  type: string,
  category: string
) {
  return api.get(
    `/activetest/tests/data?testGuid=${testGuid}&activeType=${type}&responseType=category&testDataCategoryType=${category}`
  );
}

function GetPatientTestTableDataByCategories(testGuid: string, type: string) {
  return api.get(
    `/activetest/tests/result?testGuid=${testGuid}&activeType=${type}`
  );
}

function GetActiveTestOverview(patientGuid: string) {
  return api.get(`/activetest/tests/overview/${patientGuid}`);
}

function GetActiveTestDatesByRange(
  patientGuid: string,
  activeType: string,
  startDate: string,
  endDate: string
) {
  return api.get(
    `/activetest/dates/range?accountGuid=${patientGuid}&activeType=${activeType}&dateStart=${startDate}&dateEnd=${endDate}`
  );
}

function GetActiveTestDataByDate(
  patientGuid: string,
  activeType: string,
  date: string
) {
  return api.get(
    `/activetest/tests?patientId=${patientGuid}&activeType=${activeType}&date=${date}`
  );
}

function DownloadActiveTestDataFile(
  testGuid: string,
  activeType: string,
  filename?: string
) {
  return api
    .get(
      `/activetest/tests/data?testGuid=${testGuid}&activeType=${activeType}`
    )
    .then((response: any) => {
      if (filename) saveJsonAsFile(filename, response);
      return response;
    });
}
